<script>
  import { onMount } from 'svelte';
  
  let { notice = null, security_keys = [] } = $props();
</script>

<div class="security-keys-container">
  {#if notice}
    <p class="notice">{notice}</p>
  {/if}

  <h1>Security keys</h1>
  <p>A security key is a hardware device used to verify your identity. For example, a built-in fingerprint reader, a plug-in USB key, or a login system like Windows Hello.</p>

  <ul class="security-keys-list">
    {#each security_keys as key}
      <li>
        <a href={`/two_factor_authentication/profile/security_keys/${key.id}/edit`}>{key.name}</a>
      </li>
    {/each}
  </ul>

  <div class="action-link">
    <a href="/two_factor_authentication/profile/security_keys/new">Add security key</a>
  </div>

  <div class="back-link">
    <a href="/">Back</a>
  </div>
</div>

<style>
  .security-keys-container {
    max-width: 600px;
    margin: 0 auto;
    padding: 2rem 1rem;
  }
  
  h1 {
    font-size: 1.875rem;
    font-weight: 600;
    margin-bottom: 1rem;
  }
  
  .notice {
    color: green;
    margin-bottom: 1rem;
    padding: 0.5rem;
    background-color: #ecfdf5;
    border-radius: 0.375rem;
  }
  
  .security-keys-list {
    margin: 2rem 0;
    padding-left: 1.5rem;
    line-height: 1.75;
  }
  
  .security-keys-list a {
    color: #047857;
    text-decoration: none;
  }
  
  .security-keys-list a:hover {
    text-decoration: underline;
  }
  
  .action-link, .back-link {
    margin: 1rem 0;
  }
  
  .action-link a, .back-link a {
    color: #047857;
    text-decoration: none;
  }
  
  .action-link a:hover, .back-link a:hover {
    text-decoration: underline;
  }
</style>